import React from "react";

function Progress({ message = "Loading..." }) {
  return (
    <div className="p-3 p-md-4 text-center text-muted">
      <div className="spinner-border spinner-border-sm me-2" role="status" />
      {message}
    </div>
  );
}

export default Progress;
